import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  Box,
  Link,
} from "@mui/material";
import { products } from "../data";
import ProductCard from "../components/ProductCard";

const Home = ({ onProductSelect }) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      {/* Header */}
      <AppBar position="static">
        <Toolbar
          sx={{
            flexDirection: "column",
            alignItems: "center",
            py: 1,
          }}
        >
          <a
            href="/"
            style={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              color: "inherit",
            }}
          >
            <img
              src="/logo192.png"
              alt="BGIC Logo"
              style={{ height: 50, marginRight: 16 }}
            />
            <Typography variant="h6" component="div">
              BGIC Digital Store
            </Typography>
          </a>
         
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Container sx={{ my: 4, flexGrow: 1 }}>
        <Typography variant="h4" gutterBottom textAlign="center">
          Available Products
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 2,
            justifyContent: "center",
          }}
        >
          {products.map((p) => (
            <ProductCard
              key={p.id}
              product={p}
              onClick={() => onProductSelect(p)}
            />
          ))}
        </Box>
      </Container>

      {/* Footer (Header style) */}
      {/* Footer (Header style) */}
<AppBar position="static" color="primary" component="footer">
  <Toolbar
    sx={{
      justifyContent: "space-around",
      flexWrap: "wrap",
      py: 1,
      px: 2,
    }}
  >
    <Typography variant="body2" color="inherit" textAlign="center">
      <Link
        href="https://bgicinsure.com/company-profile"
        target="_blank"
        rel="noopener"
        color="inherit"
        underline="hover"
        sx={{ mx: 1 }}
      >
        About Us
      </Link>
    </Typography>

    <Typography variant="body2" color="inherit" textAlign="center">
      <Link
        href="https://bgicinsure.com/management-team"
        target="_blank"
        rel="noopener"
        color="inherit"
        underline="hover"
        sx={{ mx: 1 }}
      >
        Management
      </Link>
    </Typography>

    {/* New Refund Link */}
    <Typography variant="body2" color="inherit" textAlign="center">
      <Link
        href="/refund"   // your refund page route
        color="inherit"
        underline="hover"
        sx={{ mx: 1 }}
      >
        Refund Application
      </Link>
    </Typography>

    <Typography variant="body2" color="inherit" textAlign="center">
      Hotline: 02223383056-8, 02223386125 | Email: info@bgicinsure.com
    </Typography>

    <Typography variant="body2" color="inherit" textAlign="center">
      Head Office: 42, Dilkusha C/A, Dhaka-1000
    </Typography>
  </Toolbar>
</AppBar>
    </Box>
  );
};

export default Home;
